import React from "react";
import moment from "moment";
import {StringBuilder} from "../../../AppUtils";
import {findInvoiceWithDelivery} from "../utils";
import {Tooltip, Dropdown, Menu} from "antd";
import {EllipsisOutlined} from "@ant-design/icons";
import {InvoicesStatusToNameAndColor} from "../../../provider/ProviderManageInvoices/consts";

const getColumns = ({invoices, onViewDelivery, onShowHistoryOrder}) => [
    {
        title: "#",
        key: "#",
        width: 50,
        render(_, __, idx) {
            return idx + 1;
        }
    },
    {
        title: "מספר הזמנה",
        width: 150,
        render(_, {proposalId}) {
            return proposalId;
        }
    },
    {
        title: "כתובת בית העסק",
        width: 200,
        render(_, {sourceAddress}) {
            return sourceAddress?.address || "-";
        }
    },
    {
        title: "מסירה כתובת",
        width: 200,
        render(_, {destinationAddress}) {
            return destinationAddress?.address || "-";
        }
    },
    {
        title: "טווח מסירה",
        width: 180,
        dataIndex: "dtstart",
        sorter: ({dtstart: r1}, {dtstart: r2}) => r1 - r2,
        render(startDate, {until}) {
            if (!startDate) return null;
            const startMoment = moment(startDate);
            const endMoment = until ? moment(until) : startMoment;
            return `${startMoment.format("DD-MM-YYYY")}, ${startMoment.format("HH:mm")}-${endMoment.format("HH:mm")}`;
        }
    },
    {
        title: "עלות משלוח",
        width: 120,
        sorter: ({price: r1}, {price: r2}) => (r1 ?? 0) - (r2 ?? 0),
        render(_, {price}) {
            return price ? new StringBuilder(price).append("₪").toString() : "₪0";
        }
    },
    {
        title: "תקלות",
        width: 100,
        render(_, delivery) {
            const {statusMessage, orderId} = delivery;
            if (!statusMessage?.length) {
                return null;
            }

            return (
                <span
                    style={{color: "var(--error-color)", cursor: "pointer"}}
                    onClick={() => {
                        if (onShowHistoryOrder && orderId) {
                            onShowHistoryOrder(delivery);
                        }
                    }}>
                    תקלות
                </span>
            );
        }
    },
    {
        title: "זיכוי במשלוח",
        width: 200,
        style: {
            direction: "ltr"
        },
        render(_, {order}) {
            return order.deliveryProviderDiscount
                ? new StringBuilder(order.deliveryProviderDiscount * -1).append("₪").toString()
                : "0 ₪";
        }
    },
    {
        title: "סטטוס חשבונית",
        key: "invoiceStatus",
        width: 150,
        render(_, {deliveryId}) {
            const deliveryInvoice = findInvoiceWithDelivery(deliveryId, invoices);
            const statusColorAndName = InvoicesStatusToNameAndColor[deliveryInvoice?.status];

            return statusColorAndName ? (
                <Tooltip
                    title={
                        deliveryInvoice?.declineMessage ? (
                            <div>
                                <span>סיבת הדחייה: </span>
                                <span>{deliveryInvoice?.declineMessage}</span>
                            </div>
                        ) : null
                    }>
                    <span style={{color: statusColorAndName.color}}>{statusColorAndName.name}</span>
                </Tooltip>
            ) : (
                ""
            );
        }
    },
    ...(onViewDelivery || onShowHistoryOrder
        ? [
              {
                  title: "פעולות",
                  width: 100,
                  render(_, delivery) {
                      const actions = [];
                      if (onViewDelivery) {
                          actions.push({
                              title: "צפייה במשלוח",
                              onClick: () => onViewDelivery(delivery)
                          });
                      }
                      if (onShowHistoryOrder) {
                          actions.push({
                              title: "היסטוריית משלוח",
                              onClick: () => onShowHistoryOrder(delivery)
                          });
                      }

                      if (!actions.length) return null;

                      return (
                          <Dropdown
                              overlay={
                                  <Menu>
                                      {actions.map(({title, onClick}, index) => (
                                          <Menu.Item key={index} onClick={() => onClick()}>
                                              {title}
                                          </Menu.Item>
                                      ))}
                                  </Menu>
                              }
                              trigger={["click"]}>
                              <EllipsisOutlined className="admin-orders-order-action-button" />
                          </Dropdown>
                      );
                  }
              }
          ]
        : [])
];

export default getColumns;
